import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddProductModalComponent } from '../add-product-modal.component';

import { Color, Size } from 'src/app/components/company/models/new/style';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Component({
	selector: 'bt-manage-colors-sizes-modal',
	standalone: false,
	templateUrl: './manage-colors-sizes-modal.component.html',
	styleUrl: './manage-colors-sizes-modal.component.scss'
})
export class ManageColorsSizesModalComponent {
	readonly data = inject(MAT_DIALOG_DATA);
	readonly dialogRef = inject(MatDialogRef<ManageColorsSizesModalComponent>);

	groupedWarehouseArticles: { color: Selectable<Color>; sizesAndQuantity: Selectable<{ size: Size; availableQty: number }>[] }[] = [];

	constructor() {
		if (this.data && this.data.style.colors && this.data.style.warehouseArticles) {
			this.groupedWarehouseArticles = this.data.style.colors.map((color: Color) => {
				const sizesAndQuantity = this.data.style.warehouseArticles
					.filter((wa: any) => wa.color && wa.color.id == color.id)
					.map((wa: any) => ({
						size: wa.size ? new Size({ id: wa.size.id,  name: wa.size.name }) : undefined,
						availableQty: wa.availableQty
					}));

				//controlla in color e metti a selected il size che c'è in color.size
				sizesAndQuantity.forEach((s: Selectable<{ size: Size; availableQty: number }>) => {
					if (color.size && s.size && color.size.id == s.size.id) {
						s.selected = true;
					}
				});

				//vedi se il color esiste in color e metti a selected il color
				const selectableColor: Selectable<Color> = { ...color, selected: false };

				this.data.style.colors.forEach((c: any) => {
					if (c.id == color.id) {
						selectableColor.selected = true;
					}
				});

				return { color: selectableColor, sizesAndQuantity };
			});

			if (!this.data.singleColorSelection) {
				//qui aggiungo i colori che non sono stati selezionati ma che fanno parte di warehouseArticles
				let groupedWarehouseArticlesNotSelectedWithAllSizes = this.data.style.warehouseArticles.reduce((acc: any, wa: any) => {
					if (wa.color && !acc.some((a: any) => a.color && a.color.id == wa.color.id)) {
						acc.push({
							color: { ...wa.color, selected: false },

							sizesAndQuantity: this.data.style.warehouseArticles
								.filter((w: any) => w.color && w.color.id == wa.color.id)
								.map((w: any) => ({
									size: w.size ? new Size({ id: w.size.id,   name: w.size.name }) : undefined,
									availableQty: w.availableQty,
									selected: false
								}))
						});
					}
					return acc;
				}, []);

				groupedWarehouseArticlesNotSelectedWithAllSizes.forEach((wa: any) => {
					if (!this.groupedWarehouseArticles.some((g) => g.color.id == wa.color.id)) {
						this.groupedWarehouseArticles.push(wa);
					}
				});
			}

			//ordina per nome i colori
			this.groupedWarehouseArticles.sort((a, b) => a.color.name!.localeCompare(b.color.name!));
		}
	}

	toggleColor(color: any) {
		color.color.selected = !color.color.selected;
		if (!color.color.selected) {
			color.sizesAndQuantity.forEach((s: any) => {
				s.selected = false;
			});
		}
	}

	disableApply() {
		//disabilita se non ci sono colori selecionati oppure se c'è qualche colore senza taglia selecionata
		const selectedColors = this.groupedWarehouseArticles.filter((c) => c.color.selected);
		if (selectedColors.length == 0) {
			return true;
		}
		for (let color of selectedColors) {
			const selectedSizes = color.sizesAndQuantity.filter((s) => s.selected);
			if (selectedSizes.length == 0) {
				return true;
			}
		}
		return false;
	}

	selectSize(color: Color, size: Selectable<{ size: Size; availableQty: number }>) {
		this.groupedWarehouseArticles.map((c) => {
			if (c.color.id == color.id) {
				c.sizesAndQuantity.forEach((s) => {
					s.selected = false;
				});
			}
		});
		size.selected = !size.selected;
	}

	close() {
		this.dialogRef.close(null);
	}

	apply() {
		this.dialogRef.close(this.groupedWarehouseArticles);
	}
}
